<template>
  <section class="organism-features-section">
    <h1 class="main-title">Features</h1>
    <p class="vision-description">
      Powerful tools built for professional drone operations and remote
      collaboration.
    </p>
    <div class="features-grid">
      <ServiceCard
        v-for="(feature, index) in features"
        :key="index"
        :icon="feature.icon"
        :image-src="feature.imageSrc"
        :title="feature.title"
        :description="feature.description"
      />
    </div>
  </section>
</template>

<script>
import ServiceCard from "@/components/molecules/ServiceCard.vue";

export default {
  name: "FeaturesSection",
  components: {
    ServiceCard,
  },
  props: {
    features: {
      type: Array,
      required: true,
      validator: (value) =>
        value.every(
          (item) => typeof item === "object" && item.title && item.description
        ),
    },
  },
};
</script>

<style scoped>
.organism-features-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 10rem 5rem;
}

.main-title {
  font-size: 3rem;
  margin-bottom: 2rem;
  text-align: center;
  color: #000;
  font-weight: bold;
}

.vision-description {
  font-size: 1.2rem;
  padding: 1rem 2rem;
  color: #7e7e7e;
  width: 75%;
  max-width: 800px;
  margin: 0 auto 4rem;
  text-align: center;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0rem;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

@media (max-width: 1200px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .organism-features-section {
    padding: 5rem 1rem;
  }

  .main-title {
    font-size: 2rem;
    margin-bottom: 2.5rem;
    font-weight: bold;
  }

  .vision-description {
    width: 100%;
    padding: 0;
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    max-width: 500px;
  }
}
</style>
